module.exports = __webpack_public_path__ + "static/img/logo.0421c8b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo.webp
// module id = n4vh
// module chunks = 0